/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import Combobox from "@ls/react-combobox-grid";
import {
  selectFactribPeriods,
  selectFactribTypes,
  selectFetchingFactribPeriods,
  selectFetchingFactribTypes,
} from "state/factrib/selectors";
import { useSelector } from "react-redux";
import { summaryTypeOptionsLegacy } from "state/selections/Constants/SummaryType";
import { Cell, Grid } from "styled-css-grid";
import { selectAsOfDateValue } from "state/selections/selector";
import SelectionState from "state/selections/SelectionState";

const factribAsOfDateOptions = ["PME", "PQE", "PYE"].map((value) => ({
  label: value,
  value,
}));

const FactribSelectorComplication = ({ setDefinition, definition }) => {
  const fetchingFactribTypes = useSelector(selectFetchingFactribTypes);
  const factribTypes = useSelector(selectFactribTypes);
  const fetchingFactribPeriods = useSelector(selectFetchingFactribPeriods);
  const factribPeriods = useSelector(selectFactribPeriods);
  const asOfDate = useSelector(selectAsOfDateValue(SelectionState.UNCOMMITTED));

  const factribTypeOptions = useMemo(
    () => factribTypes.map((val) => ({ label: val, value: val })),
    [factribTypes]
  );
  const factribPeriodOptions = useMemo(
    () => factribPeriods.map((val) => ({ label: val, value: val })),
    [factribPeriods]
  );

  const [setFactribFactor, setFactribPeriod, setFactribAsOfDate, setSummary] =
    useMemo(() => {
      return [
        (value) => setDefinition(definition.setFactribFactor(value)),
        (value) => setDefinition(definition.setFactribPeriod(value)),
        (value) => setDefinition(definition.setFactribAsOfDate(value)),
        (value) => setDefinition(definition.setSummary(value)),
      ];
    }, [definition, setDefinition]);

  return (
    <Grid columns={12} gap="4px">
      <Cell width={3}>
        <Combobox
          label="Factor:"
          labelPosition={"TOP"}
          value={definition.factribFactor}
          loading={fetchingFactribTypes}
          options={factribTypeOptions}
          onChange={setFactribFactor}
          gridHeight={200}
          size="S"
          variation={0}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          label="Period:"
          labelPosition={"TOP"}
          loading={fetchingFactribPeriods}
          options={factribPeriodOptions}
          value={definition.factribPeriod}
          onChange={setFactribPeriod}
          gridHeight={200}
          size="S"
          variation={0}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          label="Run Date:"
          labelPosition={"TOP"}
          placeholder={`(${asOfDate})`}
          options={factribAsOfDateOptions}
          value={definition.factribAsOfDate}
          onChange={setFactribAsOfDate}
          gridHeight={200}
          size="S"
          variation={0}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={summaryTypeOptionsLegacy}
          onChange={setSummary}
          value={definition.summary}
          label="Abs/Rel:"
          clearable={false}
          variation={0}
          size="S"
          gridHeight={100}
        />
      </Cell>
    </Grid>
  );
};

FactribSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(FactribSelectorComplication);
